import { Tool } from "./tool.model";

export class OperationTools {
    public operationId: number;
    public operationName: string;
    public tools: Tool[];
    public operationTitle: string;

    constructor(operationTools: any = {}) {
        this.operationId = operationTools.operationId;
        this.operationName = operationTools.operationName;
        this.tools = operationTools.tools;
    }
}
